module.exports = __webpack_public_path__ + "static/media/realestate3.ff63ab6c.png";